/**
 * @generated SignedSource<<612bc3294121fdf327b9e7bf111e5177>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProjectSubmissionStatusEnum = "private" | "public";
export type CreateProjectSubmissionInput = {
  clientMutationId?: string | null | undefined;
  description?: string | null | undefined;
  projectId?: string | null | undefined;
  projectRawId?: number | null | undefined;
  projectTitle?: string | null | undefined;
  screenshotUrl?: string | null | undefined;
  starting?: boolean | null | undefined;
  status?: ProjectSubmissionStatusEnum | null | undefined;
  url?: string | null | undefined;
};
export type useCodeTestBrowserForm_SubmitProjectSubmissionMutation$variables = {
  input: CreateProjectSubmissionInput;
};
export type useCodeTestBrowserForm_SubmitProjectSubmissionMutation$data = {
  readonly createProjectSubmission: {
    readonly projectSubmission: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type useCodeTestBrowserForm_SubmitProjectSubmissionMutation = {
  response: useCodeTestBrowserForm_SubmitProjectSubmissionMutation$data;
  variables: useCodeTestBrowserForm_SubmitProjectSubmissionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateProjectSubmissionPayload",
    "kind": "LinkedField",
    "name": "createProjectSubmission",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectSubmission",
        "kind": "LinkedField",
        "name": "projectSubmission",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCodeTestBrowserForm_SubmitProjectSubmissionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCodeTestBrowserForm_SubmitProjectSubmissionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "31f2951e6175ea48e588d6cba4ec5a36",
    "id": null,
    "metadata": {},
    "name": "useCodeTestBrowserForm_SubmitProjectSubmissionMutation",
    "operationKind": "mutation",
    "text": "mutation useCodeTestBrowserForm_SubmitProjectSubmissionMutation(\n  $input: CreateProjectSubmissionInput!\n) {\n  createProjectSubmission(input: $input) {\n    projectSubmission {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "262bd2804b97dd53231ea10f95a141eb";

export default node;
